var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 30 30",
  width: "30px",
  height: "30px",
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M 3 7 A 1.0001 1.0001 0 1 0 3 9 L 27 9 A 1.0001 1.0001 0 1 0 27 7 L 3 7 z M 3 14 A 1.0001 1.0001 0 1 0 3 16 L 27 16 A 1.0001 1.0001 0 1 0 27 14 L 3 14 z M 3 21 A 1.0001 1.0001 0 1 0 3 23 L 27 23 A 1.0001 1.0001 0 1 0 27 21 L 3 21 z"
})));

export default __webpack_public_path__ + "static/media/menu.aab8cd4d.svg";
export { SvgComponent as ReactComponent };